import { gql } from '@apollo/client'

const businessUnitTinyFragment = gql`
  fragment BusinessUnitTinyFields on BusinessUnitTiny {
    id
    name
    displayName
  }
`

export const workforceNewEntryRowFragment = gql`
  fragment WorkforceNewEntryRowFields on NewEntries {
    id
    firstName
    lastName
    avatarUrl
    currentLevel
    replyEntryDate
    contractValidFrom
    businessUnit {
      ...BusinessUnitTinyFields
    }
  }
  ${businessUnitTinyFragment}
`

export const workforceNewEntryByPeriodFragment = gql`
  fragment WorkforceNewEntryByPeriodFields on NewEntriesByPeriod {
    currentMonth {
      ...WorkforceNewEntryRowFields
    }
    previousMonth {
      ...WorkforceNewEntryRowFields
    }
  }
  ${workforceNewEntryRowFragment}
`

export const workforceLeaverRowFragment = gql`
  fragment WorkforceLeaverRowFields on Leavers {
    id
    firstName
    lastName
    avatarUrl
    leaverLevel
    contractCancellationTo
    contractCancellationType
    contractType
    contractValidFrom
    businessUnit {
      ...BusinessUnitTinyFields
    }
  }
  ${businessUnitTinyFragment}
`

export const workforceLeaverByPeriodFragment = gql`
  fragment WorkforceLeaverByPeriodFields on LeaversByPeriod {
    currentMonth {
      ...WorkforceLeaverRowFields
    }
    nextMonth {
      ...WorkforceLeaverRowFields
    }
  }
  ${workforceLeaverRowFragment}
`

export const workforceProbationPeriodEndingRowFragment = gql`
  fragment WorkforceProbationPeriodEndingRowFields on ProbationPeriodEnding {
    id
    firstName
    lastName
    avatarUrl
    currentLevel
    probationPeriodEndDate
    businessUnit {
      ...BusinessUnitTinyFields
    }
  }
  ${businessUnitTinyFragment}
`

export const workforceProbationPeriodEndingByPeriodFragment = gql`
  fragment WorkforceProbationPeriodEndingByPeriodFields on ProbationPeriodEndingByPeriod {
    currentMonth {
      ...WorkforceProbationPeriodEndingRowFields
    }
    nextMonth {
      ...WorkforceProbationPeriodEndingRowFields
    }
  }
  ${workforceProbationPeriodEndingRowFragment}
`
